import { render } from "./RegisterVie.vue?vue&type=template&id=67061c56"
import script from "./RegisterVie.vue?vue&type=script&lang=js"
export * from "./RegisterVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__